export const _invert = (object) => {
  const invertedObject = {};
  for (key of Object.keys(object)) {
    invertedObject[object[key]] = key;
  }
  return invertedObject;
};
